import { useAppSelector } from "store/store";
import { DeleteIcon } from "./DeleteIcon/DeleteIcon";
import { DownloadButton } from "./DownloadButton/DownloadButton";
import { TextSettings } from "./TextSettings/TextSettings";
import { useMemeEditor } from "../MemeEditorContext";
import { Translate } from "components/common/Translate/Translate";

export const ControlBar = () => {
    const activeTextBoxId = useAppSelector((state) => state.memeGenerator.meme?.activeTextBoxId);
    const activeIconId = useAppSelector((state) => state.memeGenerator.meme?.activeIconId);
    const { defaultMeme, isEditPage } = useMemeEditor();
    const title = useAppSelector((state) => state.memeGenerator.meme?.template.title) || defaultMeme?.title;
    const showTitle = title && !activeTextBoxId && !activeIconId;

    return (
        <div className="flex items-center justify-between py-2 pl-5 pr-4 text-black dark:text-white" id="mg-controlbar">
            <div>
                {activeTextBoxId ? <TextSettings id={activeTextBoxId} /> : <div />}
                {activeIconId ? <DeleteIcon /> : null}
                {showTitle ? (
                    isEditPage ? (
                        <h1 className="text-xl font-semibold">
                            {title.toLowerCase().split("/").at(-1) === "meme" ? (
                                <Translate keyName="create-meme-title-without-meme" variables={{ meme_title: title }} />
                            ) : (
                                <Translate keyName="create-meme-title-with-meme" variables={{ meme_title: title }} />
                            )}
                        </h1>
                    ) : (
                        <h2 className="text-xl font-semibold">{title}</h2>
                    )
                ) : null}
            </div>
            <DownloadButton />
        </div>
    );
};
